export const CURRENT_USER = {
  name: "User",
  email: "user@example.com",
  avatar: "",
};

